import { z } from 'zod/v4';

import {
  visualRunRateTypeSchema,
  visualScrapYieldTypeSchema,
} from '../operation/enums';

export const columns = {
  begin_traceability: z.string().nullable(),
  bur_per_hr_run: z.number().nullable(),
  bur_per_hr_setup: z.number().nullable(),
  bur_per_operation: z.number().nullable(),
  bur_per_unit_run: z.number().nullable(),
  bur_percent_run: z.number().nullable(),
  bur_percent_setup: z.number().nullable(),
  calc_end_qty: z.number().nullable(),
  calc_start_qty: z.number().nullable(),
  capacity_usage_max: z.number().nullable(),
  capacity_usage_min: z.number().nullable(),
  description: z.string().nullable(),
  fixed_scrap_units: z.number().nullable(),
  id: z.string(),
  load_size_qty: z.number().nullable(),
  min_segment_size: z.number().nullable(),
  minimum_move_qty: z.number().nullable(),
  move_hrs: z.number().nullable(),
  override_qtys: z.string().nullable(),
  resource_id: z.string().nullable(),
  rowid: z.number(),
  run: z.number().nullable(),
  run_cost_per_hr: z.number().nullable(),
  run_cost_per_unit: z.number().nullable(),
  run_type: visualRunRateTypeSchema.nullable(),
  schedule_type: z.number().nullable(),
  scrap_yield_pct: z.number().nullable(),
  scrap_yield_type: visualScrapYieldTypeSchema.nullable(),
  service_base_chg: z.number().nullable(),
  service_id: z.string().nullable(),
  service_min_chg: z.number().nullable(),
  service_part_id: z.string().nullable(),
  setup_cost_per_hr: z.number().nullable(),
  setup_hrs: z.number().nullable(),
  site_id: z.string(),
  test_id: z.string().nullable(),
  transit_days: z.number().nullable(),
  vendor_id: z.string().nullable(),
  vendor_service_id: z.string().nullable(),
};
